export const STATIC_SERVICES_LIST = [
    {
        label: 'Реcтораны',
        link: 'restaurants',
        disabled: false,
        warnText: '(настройки сейчас недоступны).',
    },
    {
        label: 'Продукты',
        link: 'grocers',
        disabled: false,
        warnText: '(настройки сейчас недоступны).',
    },
    {
        label: 'Аптеки',
        link: 'pharmacies',
        disabled: false,
        warnText: '(настройки сейчас недоступны).',
    }
];
